import templateUrl from './superpowershost.tpl.html';

export default {
    templateUrl,
};
